module.exports = __webpack_public_path__ + "img/icon-feedback.5b9e06d5.svg";